
/*
Un manager que permite mostrar mensajes traducidos.
*/
(function messagesModuleDefinition() {

    angular.module('Messages', ['Alerts', 'Language']);

})();